const cardContent = {
    color: 'primary.main',
    flexDirection: 'column',
    width: {
        mobile: '100%',
    },
};
const pillWraper = { display: 'flex', mt: '8px', mb: '4px', ' h5': { mt: '2px' } };
const cardSection = {
    justifyContent: 'left',
    alignItems: 'center',
    flexWrap: 'nowrap',
    ':nth-of-type(3)': { pt: 2 },
};
const salesCardFooter = {
    pt: 2,
    px: {
        mobile: 2,
    },
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'nowrap',
};
const sectionContent = {
    display: 'flex',
    alignSelf: 'flex-end',
    pb: { desktop: '5px' },
    flexDirection: {
        desktop: 'row',
    },
    columnGap: 1,
    minWidth: {
        mobile: '55%',
        desktop: '110px',
    },
    pt: {
        mobile: '3px',
        desktop: 0,
    },
    alignItems: {
        desktop: 'flex-start',
        mobile: 'center',
    },
    mr: { desktop: '6rem' },
    ' h5': { mt: '2px' },
};
const formatCurrency = {
    fontSize: {
        desktop: '20px',
    },
    alignSelf: 'flex-end',
};
const textContainer = {
    ml: {
        desktop: '3px',
        mobile: '-6px',
    },
};
export default {
    formatCurrency,
    textContainer,
    cardContent,
    sectionContent,
    cardSection,
    salesCardFooter,
    pillWraper,
};
